import React, { useState, useCallback, useEffect } from 'react';
import Slider from '@material-ui/core/Slider';
import { useStyles } from './TripleSwitch.styles';
import TooltipOne from '../TooltipOne/TooltipOne.component';

interface TripleSwitchProps {
  value: number;
  possibleValues?: number[];
  greyedValues?: number[];
  examTaskGroupName?: string;
  isAdvanceFilter?: boolean;
  onChange: (value: number) => void;
}

export const TripleSwitch: React.FC<TripleSwitchProps> = (props) => {
  const { value, possibleValues = [-1, 0, 1], greyedValues = [0], examTaskGroupName, onChange } = props;
  const styles = useStyles();
  const [activeValue, setActiveValue] = useState<number>(value);

  useEffect(() => {
    setActiveValue(value);
  }, [value]);

  const handleChange = useCallback((event: React.ChangeEvent<unknown>, value: number | number[]) => {
    setActiveValue(value as number);
    onChange(value as number);
  }, []);

  const getTooltipTitle = () => {
    switch (activeValue) {
      case -1:
        return 'System nie uwzględni zadań, w których została wybrana opcja BO';
      case 0:
        return 'System uwzględnia wszystkie zadania z 0 liczbą punktów.';
      case 1:
        return 'System uwzględnia tylko te zadania, w których wybrana została opcja BO';
      default:
        return 'System nie uwzględni zadań, w których została wybrana opcja BO';
    }
  };

  return (
    <TooltipOne
      title={
        props.isAdvanceFilter
          ? getTooltipTitle()
          : `Sprawdzanie okresu przedłużonego dostępu jest teraz ${
              activeValue === -1 ? 'włączone' : 'wyłączone'
            } dla ${examTaskGroupName}`
      }
      placement="top"
    >
      <Slider
        className={`${styles.sliderStyles} ${greyedValues?.includes(activeValue) ? styles.greyed : styles.colored}`}
        color={'primary'}
        valueLabelDisplay="off"
        marks={possibleValues.map((value: number) => {
          return { value };
        })}
        min={possibleValues[0]}
        max={possibleValues[possibleValues.length - 1]}
        track={false}
        value={activeValue}
        onChange={handleChange}
      />
    </TooltipOne>
  );
};
